/* eslint-disable no-restricted-syntax */

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
import Immutable from 'immutable';
import { UPDATE_QUALIFICATIONS } from './actions';
import { COURSE_NAVIGATION_DATA_SET } from '../CourseNavigationInfo/actions';

export function Qualifications(state = Immutable.Map(), action = {}) {
  switch (action.type) {
    case COURSE_NAVIGATION_DATA_SET:
    case UPDATE_QUALIFICATIONS: {
      const qualifications = Immutable.fromJS(action.qualifications);
      let updatedState = state;

      for (const qualification of qualifications.values()) {
        updatedState = updatedState.set(qualification.get('id'), qualification);
      }
      return updatedState;
    }
    default: {
      return state;
    }
  }
}
